import {
  MemberGroupTable,
  MemberGroup as MemberGroupType,
} from "@/types/member";
import { ApiResponse } from "@/types";

import { apiSlice } from "@/redux/apiSlice";

export const MemberGroup = apiSlice.injectEndpoints({
  endpoints(builder) {
    return {
      getMemberGroups: builder.query<MemberGroupTable, number | void>({
        query: (org_id) => ({
          url: `/member/group${org_id ? `?org_id=${org_id}` : ""}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["MemberGroup"],
      }),
      getMemberGroupById: builder.query<
        MemberGroupType,
        { id: number; org_id?: number }
      >({
        query: ({ id, org_id }) => ({
          url: `/member/group/${id}${org_id ? `?org_id=${org_id}` : ""}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["MemberGroup"],
      }),
      createMemberGroup: builder.mutation<ApiResponse, MemberGroupType>({
        query: (memberdata) => ({
          url: `/member/group`,
          method: "POST",
          body: memberdata,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }),
        invalidatesTags: ["MemberGroup"],
      }),
      updateMemberGroup: builder.mutation<
        ApiResponse,
        { memberdata: MemberGroupType; org_id?: number }
      >({
        query: ({ memberdata, org_id }) => ({
          url: `/member/group/${memberdata.id}${org_id ? `?org_id=${org_id}` : ""}`,
          method: "PUT",
          body: memberdata,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }),
        invalidatesTags: ["MemberGroup"],
      }),
      deleteMemberGroup: builder.mutation<
        ApiResponse,
        { id: number; org_id?: number }
      >({
        query: ({ id, org_id }) => ({
          url: `/member/group/${id}${org_id ? `?org_id=${org_id}` : ""}`,
          method: "DELETE",
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["MemberGroup"],
      }),
    };
  },
});

export const {
  useGetMemberGroupsQuery,
  useGetMemberGroupByIdQuery,
  useCreateMemberGroupMutation,
  useUpdateMemberGroupMutation,
  useDeleteMemberGroupMutation,
} = MemberGroup;
